import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgSearchSuggest({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 4h14a1 1 0 01.117 1.993L19 6H7.415l12.292 12.293a1 1 0 01.083 1.32l-.083.094a1 1 0 01-1.32.083l-.094-.083L6 7.415V19a1 1 0 01-.883.993L5 20a1 1 0 01-.993-.883L4 19l.001-14.054.014-.12.035-.138.044-.111.076-.136.072-.094.05-.054.113-.097.11-.071.062-.031.081-.034.129-.037.076-.014.055-.006L5 4z"
        fill={color}
      />
    </svg>
  )
}

export default SvgSearchSuggest
